import { Box, Grid2, Typography } from '@mui/material';
import React from 'react';
import DomainIcon from '@mui/icons-material/Domain';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../hooks/useAuth';
import VenueCard, { VenueCardSkeleton } from './VenueCard';
import VenuesPagination from './VenuesPagination';
import useVenueActions from '../hooks/useVenueActions';

const VenuesCardView = ({ rows, limit, page, setParams, total, loading, reloadData }) => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const { confirmDelete, switchVenue, isDeleting, isSwitching } = useVenueActions(reloadData);

    return (
        <Grid2 container spacing={3} width="100%">
            {loading
                ? Array.from({ length: limit }).map((_, index) => (
                      <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={index}>
                          <VenueCardSkeleton />
                      </Grid2>
                  ))
                : rows?.map((row) => (
                      <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={row.id}>
                          <VenueCard
                              row={row}
                              isCurrent={user?.venueId === row.id}
                              onDelete={() => confirmDelete(row)}
                              onSwitch={() => switchVenue(row.id)}
                              isSwitching={isSwitching(row.id)}
                              isDeleting={isDeleting(row.id)}
                          />
                      </Grid2>
                  ))}

            {!loading && (!rows || rows.length === 0) && (
                <Grid2 size={{ xs: 12 }}>
                    <Box sx={{ textAlign: 'center', py: 8, color: 'text.secondary' }}>
                        <DomainIcon sx={{ fontSize: 64, mb: 2, opacity: 0.5 }} />
                        <Typography variant="h6">{t('venues.noVenues')}</Typography>
                    </Box>
                </Grid2>
            )}

            <Grid2 size={{ xs: 12 }}>
                <VenuesPagination
                    rows={rows}
                    total={total}
                    limit={limit}
                    page={page}
                    setParams={setParams}
                />
            </Grid2>
        </Grid2>
    );
};

export default VenuesCardView;
